// Liste des sauces disponibles (partagée entre le modal et le sélecteur inline)
const SAUCES = [
  'Américaine forte',
  'Américaine légère',
  'Algérienne',
  'Andalouse',
  'Barbecue',
  'Bearnaise',
  'Bicky triple',
  'Brasil',
  'Chti',
  'Cocktail',
  'Curry Ketchup',
  'Curry Mangue',
  'Dallas',
  'Hamburger',
  'Hawaï',
  'Hotshot',
  'Jammie',
  'Joppie',
  'Kérozène',
  'Ketchup',
  'Loempia',
  'Mamout',
  'Mayonnaise',
  'Mayonnaise à la truffe',
  'Moutarde',
  'Pickles',
  'Pili Pili',
  'Pitta ail',
  'Poivre',
  'Provençale',
  'Riche',
  'Salsa diabla',
  'Samouraï',
  'Tartare',
  'Tartare du chef',
  'Tomagrec',
  'Toscane',
  'Ziggy',
]

export default SAUCES
